<template>
  <div class="dashboard-container">
    <Header />
    <router-view v-if="user" />
    <div v-else>You must <a :href="externalLoginLink">log in</a> first</div>
  </div>
</template>

<script>
import Header from './Header'
import { getExternalLoginLink } from '../utils/routing'
export default {
  data() {
    return {
      externalLoginLink: getExternalLoginLink(),
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    Header,
  }
}
</script>

<style lang="stylus" scoped>
</style>
